import { DOCUMENTS } from '@/const/ProformaInvoiceTypes'
import countriesEU from '@/assets/files/countriesEU.json'

// The existing single-assignment customs form handles exports from the EU.
// This only controls the optional input; it does not classify regulated goods.
export const canEnterDdsReferences = (
  senderCountry: string | undefined,
  recipientCountry: string,
  category: string,
): boolean => Boolean(
  senderCountry && countriesEU.includes(senderCountry)
  && recipientCountry && !countriesEU.includes(recipientCountry)
  && category !== DOCUMENTS,
)
